import { render, staticRenderFns } from "./SoundTherapySelectCourseStep.vue?vue&type=template&id=28a557de&scoped=true&"
import script from "./SoundTherapySelectCourseStep.vue?vue&type=script&lang=ts&"
export * from "./SoundTherapySelectCourseStep.vue?vue&type=script&lang=ts&"
import style0 from "./SoundTherapySelectCourseStep.vue?vue&type=style&index=0&id=28a557de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a557de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCard,VRadioGroup})
